import React, { useState, useEffect, useContext } from "react";
import "../../styles/pages/enquiry/NonClubsMember.scss";
import { GlobalContext } from "../../App";
import { enquiryContext } from "./Enquiry";
import { Trans, useTranslation } from "react-i18next";
function NonClubsMember() {
  const { enquiryLoginData, setenquiryLoginData, handleEnquiry, error } =
    useContext(enquiryContext);
  const [canEnquiry, setCanEnquiry] = useState(false);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (enquiryLoginData.email !== "" && enquiryLoginData.phone !== "") {
      setCanEnquiry(true);
    } else {
      setCanEnquiry(false);
    }
  }, [enquiryLoginData.email, enquiryLoginData.phone]);

  return (
    <div className="non-clubs-member-container">
      <div className="title-container">
        <div className="email-phone">
          {" "}
          <Trans i18nKey="enquiry:enter" />
        </div>
      </div>
      <div className="input-container">
        <span className="input-label">
          {" "}
          <Trans i18nKey="enquiry:email" />
        </span>
        <input
          className="input-box"
          onChange={(e) =>
            setenquiryLoginData((prev) => ({
              ...prev,
              email: e.target.value,
            }))
          }
        ></input>
      </div>
      <div className="input-container">
        <span className="input-label">
          <Trans i18nKey="enquiry:phone" />
        </span>
        <input
          className="input-box"
          type="phone"
          onChange={(e) =>
            setenquiryLoginData((prev) => ({
              ...prev,
              phone: e.target.value,
            }))
          }
        ></input>
      </div>
      <div className="error"> {error ? <>error</> : <></>}</div>
      <button
        className={canEnquiry ? "enquiry-button" : "cant-enquiry-button"}
        onClick={handleEnquiry}
        disabled={!canEnquiry}
      >
        <Trans i18nKey="enquiry:inquiry" />
      </button>
    </div>
  );
}

export default NonClubsMember;
